import map from 'lodash/map';

import SelectIcon from '~/components/icons/SelectIcon';
import { countryNames } from '~/lib/helpers';

const CountryCode = (props) => {
  const renderCountryCodeOption = (name, code) => (
    <option key={code} value={code}>
      {name}
    </option>
  );

  return (
    <div className="cb-select">
      <select {...props}>
        <option />
        {map(countryNames, renderCountryCodeOption)}
      </select>
      <SelectIcon className="cb-arrow" />
    </div>
  );
};

export default CountryCode;
